import { useParams } from "react-router-dom";
import ProjectShell from "../components/ProjectShell";
import { useProjectContracts } from "@/hooks/useProjectContracts";
import SummarySection from "./components/SummarySection";
import ContractsList from "@/components/financial/contracts/ContractsList";

function FinancialContent({ projectId }: { projectId: string }) {
  const { contracts, loading: contractsLoading } = useProjectContracts(projectId);

  return (
    <div className="space-y-8">
      <SummarySection projectId={projectId} />
      <ContractsList contracts={contracts} loading={contractsLoading} />
    </div>
  );
}

export default function ProjectFinancial() {
  const { id } = useParams<{ id: string }>();

  return (
    <ProjectShell projectId={id!} activeTab="financial">
      <FinancialContent projectId={id!} />
    </ProjectShell>
  );
}
